if (!customElements.get('size-chart-modal')) {
  class SizeChartModal extends HTMLElement {
    optionName = null
    constructor() {
      super()
      this.content = this.querySelector('.size-chart-modal__content')
    }

    connectedCallback() {
      this.addEventListener('click', this.close.bind(this))
      this.content.addEventListener('click', (e) => e.stopPropagation())
      this.addEventListener('change', this.handleChange.bind(this))
      this.querySelector('.js-close').addEventListener('click', this.close.bind(this))
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.close.bind(this))
      this.content.removeEventListener('click', (e) => e.stopPropagation())
      this.removeEventListener('change', this.handleChange.bind(this))
      this.querySelector('.js-close').removeEventListener('click', this.close.bind(this))
    }

    open() {
      this.classList.add('is-open')
      const openedImage = this.content.querySelector('[data-unit-system]:not(.hidden)')
      if (openedImage) {
        const aspectRatio = openedImage.querySelector('[data-aspect-ratio]').dataset.aspectRatio
        if (aspectRatio <= 1.3) {
          this.style.setProperty('--max-width', '570px')
        } else {
          this.style.setProperty('--max-width', '70%')
        }
      }
      this.checkForOptionName()
    }

    close() {
      this.classList.remove('is-open')
    }

    checkForOptionName() {
      if (this.querySelectorAll('[data-option-name]').length > 0 && this.optionName) {
        const styleOptions = this.querySelector('.js-style-options')
        if (styleOptions) {
          styleOptions.remove()
        }
        const style = `<style class="js-style-options">
          .size-chart-modal .desktop-image[data-option-name="${this.optionName}"]{
            @media (min-width: 768px) {
              display: block;
            }
          }
          .size-chart-modal .mobile-image[data-option-name="${this.optionName}"] {
            @media (max-width: 768px) {
              display: block;
            }
          }
          .size-chart-modal .desktop-image:not([data-option-name="${this.optionName}"]){
            @media (min-width: 768px) {
              display: none;
            }
          }
          .size-chart-modal .mobile-image:not([data-option-name="${this.optionName}"]) {
            @media (max-width: 768px) {
              display: none;
            }
          }
        </style>`
        this.insertAdjacentHTML('afterbegin', style)
      }
    }

    handleChange(e) {
      const name = e.target.name
      const value = e.target.value

      switch (name) {
        case 'size-unit':
          const imageContainers = this.content.querySelectorAll('[data-unit-system]')
          imageContainers.forEach((container) => {
            if (container.dataset.unitSystem === value) {
              const aspectRatio = container.querySelector('[data-aspect-ratio]').dataset.aspectRatio
              if (aspectRatio <= 1.3) {
                this.style.setProperty('--max-width', '570px')
              } else {
                this.style.setProperty('--max-width', '70%')
              }
              container.classList.remove('hidden')
            } else {
              container.classList.add('hidden')
            }
          })
          break

        case 'view':
          let targetSelector = ''
          if (value == 'chart') {
            targetSelector = '.size-chart-modal__image-container--chart'
          } else if (value == 'model-guide') {
            targetSelector = '.size-chart-modal__image-container--model-guide'
          }
          if (this.querySelector(targetSelector) !== null) {
            this.querySelectorAll('.size-chart-modal__image-container').forEach((container) => {
              container.style.display = 'none'
            })
            this.querySelector(targetSelector).style.display = 'block'
          }
          break
        default:
      }
    }
  }
  customElements.define('size-chart-modal', SizeChartModal)
}
